import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPump = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M6 3c-.552 0-1 .448-1 1v16c0 .552.448 1 1 1h12c.552 0 1-.448 1-1V4c0-.552-.448-1-1-1H6zm12-2c1.657 0 3 1.343 3 3v16c0 1.657-1.343 3-3 3H6c-1.657 0-3-1.343-3-3V4c0-1.657 1.343-3 3-3h12zm-6 8c-2.761 0-5 2.239-5 5s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5zm0 2c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"
	})
});
export default SvgPump;
